
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { UploadFile, AnalyzeTongue, AnalyzeFace, GetExeImg } from "../../request";
import { initData } from "../../common";
@Component({})
export default class Wang extends Vue {
    @Prop()
    private temDate: any;
    @Prop()
    private visible: any;
    @Prop()
    private patient_id: any;
    private ifShow: any = false;
    private data: any = {};
    private stream: any = "";
    private photoData: any = "";
    private imgData: any = [];
    private imgs: any = [];
    private devices: any = [];
    private cDevice: any = {};
    private filming: any = false;
    private times: any = 0; // 当前查找次数
    private maxTimes: any = 4; // 最大重复次数
    private cameraTimes: any = 0;
    private readying: any = false;
    private step: any = 0;
    private stepList: any = ['舌', '舌下', '面', '脉']
    private sizhenData: any = {
        '舌': null,
        '舌下': null,
        '面': null,
        '脉': null,
    };
    @Watch("visible", { immediate: true })
    private async visibleChange() {
        this.ifShow = this.visible;
        if (this.ifShow) {
            this.data = JSON.parse(JSON.stringify(this.temDate));
            if (this.data.form_oid == 'AI体质测评（竖）' || this.data.form_oid == 'AI辅助辨证（竖）') {
                this.data.camera_rotation_angle = '0'
            } else if (this.data.form_oid == 'AI体质测评（横）' || this.data.form_oid == 'AI辅助辨证（横）') {
                this.data.camera_rotation_angle = '90'
            }
            this.imgs = [];
            this.imgData = [];
            this.filming = false;
            this.readying = false;
            this.photoData = ''
            this.devices = [];
            this.cDevice = {};
            this.times = 0;
            this.cameraTimes = 0;
            this.readying = false;
            this.step = 0;
            // 关闭紫光
            console.log("打开弹框后：紫外光-OFF");
            const res = await window.electronMyAPI.changeLight("紫外光-OFF");
            console.log("关闭紫光", res);
            if (res) {
                this.$store.commit("updateIfShowZiwai", false);
                // 打开均匀光
                window.electronMyAPI.changeLight("白光-ON-100");
            }
            this.getCameraDevices();
        }
    }
    private cancel() {
        this.$emit("cancel");
        if (this.stream) {
            this.stream.getTracks().forEach((track: any) => track.stop());
        }
        this.resetCamera();
        this.imgs = [];
        this.imgData = [];
        this.devices = [];
        this.cDevice = {};
        this.filming = false;
        // 关闭均匀光
        console.log("关闭白光");
        window.electronMyAPI.changeLight("白光-OFF");
    }
    private selectDevice(item: any) {
        this.cDevice = item;
        this.startCamera();
    }
    private goNext() {
        if (this.step < 2) {
            this.step++;
            this.resetPhoto();
        } else if (this.step == 2) {
            this.step++;
            //切换拍脉象
            this.goMaizhen();
        }
    }
    private goMaizhen() {
        const type = 'real'; // mock 模拟数据,real 真实数据
        if (type == 'real') {
            const uid = Date.now() + "_" + this.patient_id;
            window.electronMyAPI.launchExe("pulse", uid);
            // 弹出中间弹框
            this.$confirm("是否在设备上采集完成？", "脉诊采集", {
                customClass: "commonConfirm",
                confirmButtonClass: "iconfont icon-anniu4 confirmSure",
                confirmButtonText: "采集完成",
                cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
                cancelButtonText: "跳过",
                closeOnClickModal: false,
                closeOnPressEscape: false,
            }).then(async () => {
                // 上传脉
                const exeRes = await window.electronMyAPI.uploadPulse(uid);
                // 先获取图片填充到value，然后保存content
                const loading = this.$loading({
                    lock: true,
                    text: "加载中……",
                    spinner: "el-icon-loading",
                    customClass: "loadClass",
                    background: "rgba(255, 255, 255, 0.7)",
                });
                const params: any = {
                    params: {
                        uid: exeRes,
                        name: "pulse",
                    },
                };
                GetExeImg(this, params, loading).then(async (res: any) => {
                    loading.close();
                    if (res.code == 2000) {
                        this.sizhenData[this.stepList[this.step]] = res.data;
                        this.goFinish();

                    } else {
                        this.$confirm("对不起，采集失败，请重新采集！", "脉诊采集", {
                            customClass: "commonConfirm",
                            confirmButtonClass: "iconfont icon-anniu4 confirmSure",
                            cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
                            confirmButtonText: "重新采集",
                            cancelButtonText: "返回",
                        })
                            .then(() => {
                                this.goMaizhen();
                            })
                    }
                });
            }).catch(() => {
                this.goFinish();
            });
        } else {
            const res = {
                data: {
                    imgs: [
                        "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Seg-264-1-2.jpg",
                        "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Best-264-1-2.jpg",
                        "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/PH-264-1-2.jpg"
                    ],
                    report: {
                        pulse_hand: '右手',
                        pulse_pos: '尺脉',
                        "连续脉图": "",
                        "分段压脉图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Seg-264-1-2.jpg",
                        "最佳压力脉图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/Best-264-1-2.jpg",
                        "脉象p-h趋势图": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/PH-264-1-2.jpg",
                        "脉象信息输出": {
                            "脉位": "浮",
                            "脉力": "有力",
                            "脉名": "其它脉",
                            "脉率": "慢(71times/min)",
                            "流利度": "",
                            "紧张度": "",
                            "脉节律": "不齐"
                        },
                        "最佳脉象图参数": {
                            "A": 0,
                            "t": 0.38,
                            "Ad": -5.35326,
                            "As": 196.472,
                            "h1": 46.0749,
                            "h2": 43.1337,
                            "h3": 42.9087,
                            "h4": 3.07369,
                            "h5": -4.37927,
                            "t1": 0.172,
                            "t2": 0.204,
                            "t3": 0.205,
                            "t4": 0.308,
                            "t5": 0.072,
                            "w1": 0.127,
                            "w2": 0.087,
                            "t1/t": 0.45,
                            "w1/t": 0.33,
                            "w2/t": 0.23,
                            "h3/h1": 0.93,
                            "h4/h1": 0.07,
                            "h5/h1": -0.1,
                            "t5/t4": 0.23
                        }
                    }
                }

            }
            this.$confirm("是否在设备上采集完成？", "脉诊采集", {
                customClass: "commonConfirm",
                confirmButtonClass: "iconfont icon-anniu4 confirmSure",
                confirmButtonText: "采集完成",
                cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
                cancelButtonText: "跳过",
                closeOnClickModal: false,
                closeOnPressEscape: false,
            }).then(async () => {
                this.sizhenData[this.stepList[this.step]] = res.data;
                this.goFinish();
            }).catch(() => {
                this.goFinish();
            });
        }

    }
    private goFinish() {
        console.log('goFinish');
        console.log(this.sizhenData);
        // 先要处理默认数据
        // 这里是处理成正常量表里面一样的格式,便于数据展示和默认值的填充
        let d: any = {};
        if (this.sizhenData['舌']) {
            d['舌'] = {
                data: [{ type: '舌象80' }],
                report: this.sizhenData['舌'].origin
            }
            d['舌'].report.imgs = [this.sizhenData['舌'].pic_url, this.sizhenData['舌'].cut_tongue_url];
        }
        if (this.sizhenData['舌下']) {
            d['舌下'] = {
                data: [{ type: '舌底' }],
                report: this.sizhenData['舌下'].origin
            }
            d['舌下'].report.imgs = [this.sizhenData['舌下'].pic_url, this.sizhenData['舌下'].cut_tongue_url];
        }
        if (this.sizhenData['面']) {
            d['面'] = {
                data: [{ type: '面象15' }],
                report: this.sizhenData['面'].origin
            }
            d['面'].report.imgs = [this.sizhenData['面'].pic_url];
        }
        if (this.sizhenData['脉']) {
            d['脉'] = {
                data: [{ type: '脉象6' }],
                report: this.sizhenData['脉'].report
            }
            d['脉'].report.imgs = this.sizhenData['脉'].imgs;
        }
        const result = {
            舌: d['舌'] ? initData(JSON.parse(JSON.stringify(d['舌']))) : null,
            舌下: d['舌下'] ? initData(JSON.parse(JSON.stringify(d['舌下']))) : null,
            面: d['面'] ? initData(JSON.parse(JSON.stringify(d['面']))) : null,
            脉: d['脉'] ? initData(JSON.parse(JSON.stringify(d['脉']))) : null
        };
        window.electronMyAPI.changeLight("白光-OFF");
        this.cancel();
        this.$emit("confirm", result);
    }
    private resetPhoto() {
        this.imgs = [];
        this.imgData = [];
        this.resetCamera();
        this.startCamera();
    }
    private resetCamera() {
        // 重置photoData和Canvas
        this.stream = "";
        this.photoData = "";
        const canvas = this.$refs.canvas as HTMLCanvasElement;

        if (canvas) {
            const context: any = canvas.getContext("2d");
            context.clearRect(0, 0, canvas.width, canvas.height);
        }
    }
    private startTakePhoto() {
        this.takePhoto().then(() => {

            this.upload(this.imgData[0]).then((res: any) => {
                this.sizhenData[this.stepList[this.step]] = res;
                this.goNext();
            });
        });
    }
    private upload(d: any) {
        return new Promise((resolve, reject) => {
            // 将 photoData 转换为 Blob 对象
            const blob = this.base64ToBlob(d);
            // 获取当前时间的时间戳（毫秒级）
            const timestamp = Date.now();
            const filename = `${timestamp}.jpg`;
            // FormData 对象
            const form = new FormData();
            // Blob 对象作为文件添加到表单中
            form.append("image", blob, filename); // 可以指定文件名
            const loading = this.$loading({
                lock: true,
                text: "图片分析中……",
                spinner: "el-icon-loading",
                customClass: "loadClass",
                background: "rgba(255, 255, 255, 0.7)",
            });
            if (this.step < 2) {
                const data = {
                    "code": 2000,
                    "data": {
                        "cut_tongue_url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/5d43a1bb-3d4d-4020-bc87-54b887cef52d_tongue_1758090089_8458.jpg",
                        "tongue_info": "青紫,,,黄,厚,有,,,,,,有",
                        "origin": {
                            "舌象照片": {
                                "分割前图片": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/5d43a1bb-3d4d-4020-bc87-54b887cef52d_tongue_1758090089_8458.jpg",
                                "分割后图片": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/5d43a1bb-3d4d-4020-bc87-54b887cef52d_tongue_1758090089_8458.jpg"
                            },
                            "舌象信息输出": [
                                "青紫",
                                "",
                                "",
                                "黄",
                                "厚",
                                "有",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "有"
                            ],
                            "舌色参数": [
                                [
                                    51.61,
                                    51.61,
                                    51.61,
                                    51.61,
                                    51.61,
                                    51.61
                                ],
                                [
                                    133.94,
                                    133.94,
                                    133.94,
                                    133.94,
                                    133.94,
                                    133.94
                                ],
                                [
                                    132.91,
                                    132.91,
                                    132.91,
                                    132.91,
                                    132.91,
                                    132.91
                                ],
                                [
                                    "",
                                    "",
                                    "",
                                    "",
                                    "",
                                    ""
                                ]
                            ],
                            "苔色参数": [
                                [
                                    29.37,
                                    29.37,
                                    29.37,
                                    29.37,
                                    29.37,
                                    29.37
                                ],
                                [
                                    130.07,
                                    130.07,
                                    130.07,
                                    130.07,
                                    130.07,
                                    130.07
                                ],
                                [
                                    129.48,
                                    129.48,
                                    129.48,
                                    129.48,
                                    129.48,
                                    129.48
                                ],
                                [
                                    "",
                                    "",
                                    "",
                                    "",
                                    "",
                                    ""
                                ]
                            ]
                        },
                        "pic_url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/f401647d-282c-4241-9ce0-6d8639866771_tongue_upload_1758090087.jpg"
                    },
                    "msg": "success"
                }
                // loading.close();
                // resolve(data);
                // return;
                AnalyzeTongue(this, form, loading)
                    .then((res: any) => {
                        loading.close();
                        console.log('上传成功');
                        console.log(res);
                        if (res.code == 2000) {
                            console.log('上传成功')
                            resolve(res.data);
                        } else {
                            this.$message.error(res.msg);
                            this.resetPhoto();
                            reject();
                        }
                    })
                    .catch(() => {
                        loading.close();
                        this.$message.error("分析失败");
                        this.resetPhoto();
                        reject();
                    });
            } else if (this.step == 2) {
                const data = {
                    "code": 2000,
                    "data": {
                        "cut_face_url": "",
                        "face_info": "红黄隐隐，明润含蓄,无,无,少量光泽,红",
                        "origin": {
                            "面象照片": {
                                "分割前图片": "",
                                "分割后图片": ""
                            },
                            "面色唇色参数": [
                                [
                                    "129.059",
                                    "112.852",
                                    "91.6987",
                                    "97.4189",
                                    "90.2024",
                                    "94.664",
                                    "167.612"
                                ],
                                [
                                    "131.075",
                                    "133.926",
                                    "131.582",
                                    "131.688",
                                    "132.678",
                                    "130.915",
                                    "128.276"
                                ],
                                [
                                    "134.355",
                                    "136.54",
                                    "138.826",
                                    "135.588",
                                    "139.36",
                                    "137.374",
                                    "127.919"
                                ],
                                [
                                    "红黄隐隐，明润含蓄",
                                    "",
                                    "",
                                    "",
                                    "",
                                    "",
                                    "红"
                                ]
                            ],
                            "面象信息输出": [
                                "红黄隐隐，明润含蓄",
                                "无",
                                "无",
                                "少量光泽",
                                "红"
                            ],
                            "content_data": [
                                {
                                    "value": {
                                        "imgs": [
                                            {
                                                "url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/1ab816a7-a142-4c04-91a0-a15b14d5e7d3_face_upload_1758157618.jpg",
                                                "description": "面象原始图片"
                                            }
                                        ]
                                    }
                                }
                            ]
                        },
                        "pic_url": "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/1ab816a7-a142-4c04-91a0-a15b14d5e7d3_face_upload_1758157618.jpg"
                    },
                    "msg": "success"
                }
                // loading.close();
                // resolve(data);
                // return
                AnalyzeFace(this, form, loading)
                    .then((res: any) => {
                        loading.close();
                        if (res.code == 2000) {
                            resolve(res.data);
                        } else {
                            this.$message.error(res.msg);
                            this.resetPhoto();
                            reject();
                        }
                    })
                    .catch(() => {
                        loading.close();
                        this.$message.error("分析失败");
                        this.resetPhoto();
                        reject();
                    });
            }
        });
    }
    private async takePhoto() {
        return new Promise((resolve, reject) => {
            if (this.stream) {
                if (this.data.camera_rotation_angle == '90' || this.data.support_take_photos || this.data.support_USB) {
                    const video = this.$refs.video as HTMLVideoElement;
                    // const canvas = this.$refs.canvas as HTMLCanvasElement;
                    const canvas = document.createElement("canvas"); // 创建一个新的canvas元素，不添加到DOM中

                    // 设置 Canvas 尺寸为视频帧旋转后的尺寸
                    canvas.width = video.videoHeight; // 旋转后的宽度是原始高度
                    canvas.height = video.videoWidth; // 旋转后的高度是原始宽度
                    const context: any = canvas.getContext("2d");

                    // 清除画布
                    context.clearRect(0, 0, canvas.width, canvas.height);

                    // 保存当前状态
                    context.save();

                    // 转换原点至画布中心
                    context.translate(canvas.width / 2, canvas.height / 2);

                    // 旋转画布90度（顺时针）
                    context.rotate(Math.PI / 2);

                    // 绘制视频帧
                    context.drawImage(
                        video,
                        0,
                        0, // 从视频左上角开始，绘制整个视频帧
                        video.videoWidth,
                        video.videoHeight, // 视频帧的原始宽度和高度
                        -video.videoWidth / 2,
                        -video.videoHeight / 2, // 从画布中心点的x轴负方向开始（旋转后的y轴）
                        video.videoWidth,
                        video.videoHeight // 使用视频帧的原始尺寸绘制到画布上
                    );

                    // 恢复状态
                    context.restore();

                    // 捕获旋转后的图像数据
                    // this.photoData = canvas.toDataURL("image/png");
                    // this.imgData.push(this.photoData);
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                // 创建一个 FileReader 来读取 Blob 并转换为 DataURL（如果需要的话）
                                const reader = new FileReader();
                                reader.onload = (e: any) => {
                                    this.photoData = e.target.result;
                                    this.imgData.push(this.photoData);
                                    resolve(true);
                                };
                                reader.readAsDataURL(blob);
                            } else {
                                reject(new Error("Failed to generate image blob"));
                            }
                        },
                        "image/jpeg",
                        0.7
                    ); // 这里指定了输出格式为 JPEG，并设置了质量为 0.7
                } else if (this.data.camera_rotation_angle == '180') {
                    const video = this.$refs.video as HTMLVideoElement;
                    const canvas = document.createElement("canvas");

                    // 正确设置 Canvas 尺寸为视频帧的尺寸
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;

                    const context = canvas.getContext("2d");

                    if (!context) {
                        reject(new Error("无法获取 canvas 上下文"));
                        return;
                    }

                    // 清除画布
                    context.clearRect(0, 0, canvas.width, canvas.height);

                    // 保存当前状态
                    context.save();

                    // 转换原点至画布中心
                    context.translate(canvas.width / 2, canvas.height / 2);

                    // 旋转画布 180 度（顺时针）
                    context.rotate(Math.PI);

                    // 绘制视频帧
                    context.drawImage(
                        video,
                        -video.videoWidth / 2,
                        -video.videoHeight / 2,
                        video.videoWidth,
                        video.videoHeight
                    );

                    // 恢复状态
                    context.restore();

                    // 捕获旋转后的图像数据
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                // 创建一个 FileReader 来读取 Blob 并转换为 DataURL（如果需要的话）
                                const reader = new FileReader();
                                reader.onload = (e: any) => {
                                    this.photoData = e.target.result;
                                    this.imgData.push(this.photoData);
                                    resolve(true);
                                };
                                reader.readAsDataURL(blob);
                            } else {
                                reject(new Error("无法生成图像 Blob"));
                            }
                        },
                        "image/jpeg",
                        0.7
                    ); // 这里指定了输出格式为 JPEG，并设置了质量为 0.7
                } else if (this.data.camera_rotation_angle == '270') {
                    const video = this.$refs.video as HTMLVideoElement;
                    // const canvas = this.$refs.canvas as HTMLCanvasElement;
                    const canvas = document.createElement("canvas"); // 创建一个新的canvas元素，不添加到DOM中

                    // 设置 Canvas 尺寸为视频帧旋转后的尺寸
                    canvas.width = video.videoHeight; // 旋转后的宽度是原始高度
                    canvas.height = video.videoWidth; // 旋转后的高度是原始宽度
                    const context: any = canvas.getContext("2d");

                    // 清除画布
                    context.clearRect(0, 0, canvas.width, canvas.height);

                    // 保存当前状态
                    context.save();

                    // 转换原点至画布中心
                    context.translate(canvas.width / 2, canvas.height / 2);

                    // 旋转画布90度（逆时针）
                    context.rotate(-Math.PI / 2);

                    // 绘制视频帧
                    context.drawImage(
                        video,
                        0,
                        0, // 从视频左上角开始，绘制整个视频帧
                        video.videoWidth,
                        video.videoHeight, // 视频帧的原始宽度和高度
                        -video.videoWidth / 2,
                        -video.videoHeight / 2, // 从画布中心点的x轴负方向开始（旋转后的y轴）
                        video.videoWidth,
                        video.videoHeight // 使用视频帧的原始尺寸绘制到画布上
                    );

                    // 恢复状态
                    context.restore();

                    // 捕获旋转后的图像数据
                    // this.photoData = canvas.toDataURL("image/png");
                    // this.imgData.push(this.photoData);
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                // 创建一个 FileReader 来读取 Blob 并转换为 DataURL（如果需要的话）
                                const reader = new FileReader();
                                reader.onload = (e: any) => {
                                    this.photoData = e.target.result;
                                    this.imgData.push(this.photoData);
                                    resolve(true);
                                };
                                reader.readAsDataURL(blob);
                            } else {
                                reject(new Error("Failed to generate image blob"));
                            }
                        },
                        "image/jpeg",
                        0.7
                    ); // 这里指定了输出格式为 JPEG，并设置了质量为 0.7
                } else {
                    const video = this.$refs.video as HTMLVideoElement;
                    // const canvas = this.$refs.canvas as HTMLCanvasElement;
                    const canvas = document.createElement("canvas"); // 创建一个新的canvas元素，不添加到DOM中

                    // 设置 Canvas 尺寸为视频帧旋转后的尺寸
                    canvas.width = video.videoWidth; // 旋转后的宽度是原始高度
                    canvas.height = video.videoHeight; // 旋转后的高度是原始宽度
                    const context: any = canvas.getContext("2d");

                    // 清除画布
                    context.clearRect(0, 0, canvas.width, canvas.height);

                    // 绘制视频帧
                    context.drawImage(
                        video,
                        0,
                        0, // 从视频左上角开始，绘制整个视频帧
                        video.videoWidth,
                        video.videoHeight, // 视频帧的原始宽度和高度
                        0,
                        0,
                        video.videoWidth,
                        video.videoHeight // 使用视频帧的原始尺寸绘制到画布上
                    );

                    // 恢复状态
                    context.restore();

                    // 捕获旋转后的图像数据
                    // this.photoData = canvas.toDataURL("image/png");
                    // this.imgData.push(this.photoData);
                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                // 创建一个 FileReader 来读取 Blob 并转换为 DataURL（如果需要的话）
                                const reader = new FileReader();
                                reader.onload = (e: any) => {
                                    this.photoData = e.target.result;
                                    this.imgData.push(this.photoData);
                                    resolve(true);
                                };
                                reader.readAsDataURL(blob);
                            } else {
                                reject(new Error("Failed to generate image blob"));
                            }
                        },
                        "image/jpeg",
                        0.7
                    ); // 这里指定了输出格式为 JPEG，并设置了质量为 0.7
                }

            }
        });
    }
    private async getCameraDevices() {
        this.times = 1;
        console.log("查找次数：" + this.times);
        const loading = this.$loading({
            lock: true,
            text: "查找设备中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        try {
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
                loading.close();
                setTimeout(() => {
                    this.getCameraDevices2();
                }, 1000);
                return;
            }

            const devices = await navigator.mediaDevices.enumerateDevices();
            console.log("设备列表", devices);
            this.devices = devices.filter((device) => device.kind === "videoinput");
            loading.close();
            if (this.devices.length == 0) {
                // this.$message.warning("没有符合条件的设备");
                setTimeout(() => {
                    this.getCameraDevices2();
                }, 1000);
            } else {
                // 选择第一个设备并启动摄像头
                console.log("设备列表", this.devices);
                this.cDevice = this.devices[0];
                await this.startCamera();
            }

        } catch (err) {
            console.error("getCameraDevices", err);
            loading.close();
            setTimeout(() => {
                this.getCameraDevices2();
            }, 1000);
        }
    }
    private async getCameraDevices2() {
        this.times += 1;
        console.log("查找次数：" + this.times);
        const loading = this.$loading({
            lock: true,
            text: "查找设备中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
        });
        try {
            if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
                // alert("enumerateDevices 不可用");
                loading.close();
                // this.$message.warning("enumerateDevices 不可用");
                setTimeout(() => {
                    if (this.times < 5) {
                        this.getCameraDevices2();
                    }
                }, 1000);
                return;
            }

            navigator.mediaDevices
                .enumerateDevices()
                .then((devices) => {
                    console.log("设备列表");
                    console.log(devices);
                    this.devices = devices.filter(
                        (device) => device.kind === "videoinput"
                    );
                    loading.close();
                    if (this.devices.length == 0) {
                        // this.$message.warning("没有符合条件的设备");
                        setTimeout(() => {
                            if (this.times < this.maxTimes) {
                                this.getCameraDevices2();
                            }
                        }, 1000);
                    }
                })
                .catch((error) => {
                    console.error("列出摄像头时发生错误:", error);
                    loading.close();
                    // this.$message.warning("没有符合条件的设备");
                    setTimeout(() => {
                        if (this.times < this.maxTimes) {
                            this.getCameraDevices2();
                        }
                    }, 1000);
                });
        } catch (err) {
            console.error("getCameraDevices2", err);
            loading.close();
            // this.$message.warning("没有符合条件的设备");
            setTimeout(() => {
                if (this.times < this.maxTimes) {
                    this.getCameraDevices2();
                }
            }, 1000);
        }
    }
    private async startCamera() {
        console.log('当前设备')
        console.log(this.cDevice);
        this.readying = true;
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    //ideal理想值
                    // exact精确值
                    // min最小值
                    // max最大值
                    deviceId: { ideal: this.cDevice.deviceId },
                    width: { ideal: 3840 },
                    height: { ideal: 2880 },
                },
            });
            (this.$refs.video as any).srcObject = this.stream;
            (this.$refs.video2 as any).srcObject = this.stream;
            this.readying = false;
        } catch (err) {
            console.error("相机初始化失败:", err);
            this.readying = false;
            if (this.cameraTimes < 4) {
                this.cameraTimes += 1;
                this.startCamera()

            } else {
                this.cameraTimes = 0;
                this.$message.error("设备连接失败，请检查设备连接状态");
                this.cDevice = {};
            }

        }
    }
    base64ToBlob(base64Data: string, contentType = ""): Blob {
        contentType = contentType || base64Data.split(",")[0].split(":")[1];
        const sliceSize = 1024;
        const byteCharacters = atob(base64Data.split(",")[1]);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
}

